<template>
    <div class="class-1">
      <!-- Header -->
      <AppHeader />
  
      <!-- Registration Form -->
      <div class="container mt-4">
        <div class="row">
          <div class="col-12">
            <h2>Waiter Details</h2>
            <form @submit.prevent="handleRegister">
              <input type="text" class="form-control" id="name" v-model="form.name" 
       placeholder="Enter Waiter Name" required autocomplete="new-password">

<input type="password" class="form-control" id="password" v-model="form.password" 
       placeholder="Enter Password" required autocomplete="new-password">
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="branch">Branch</label>
                  <select class="form-control" id="branch" v-model="form.branchId" required>
                    <option value="" disabled selected>Select Branch</option>
                    <option v-for="branch in branches" :key="branch.id" :value="branch.id">
                      {{ branch.name || 'Unnamed Branch' }} ({{ branch.ERP_CustomerName }})
                    </option>
                  </select>
                  <small class="text-danger" v-if="errors.branchId">{{ errors.branchId[0] }}</small>
                </div>
              </div>
  
              <!-- <div class="form-row">
                <div class="form-group col-md-12">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="isSuspend" v-model="form.isSuspend">
                    <label class="form-check-label" for="isSuspend">Suspend this waiter</label>
                  </div>
                </div>
              </div> -->
  
              <div class="form-row">
                <div class="form-group col-12 d-flex justify-content-between">
                  <button type="button" class="btn btn-secondary" @click="clearForm">Cancel</button>
                  <button type="submit" class="btn btn-primary">Register Waiter</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
  
      <!-- Footer -->
    </div>
  </template>
  
  <script>
  import { BASE_API_URL } from '@/config'; 
  export default {
    data() {
      return {
        form: {
          name: '',
          branchId: '',
          isSuspend: false,
          password: ''
        },
        branches: [],
        currentDate: '',
        currentTime: '',
        errors: {}
      };
    },
    mounted() {
      this.updateDateTime();
      this.startDateTimeUpdate();
      this.fetchBranches();
     
    },
    methods: {
      updateDateTime() {
        const now = new Date();
        this.currentDate = now.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
        this.currentTime = now.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
      },
      startDateTimeUpdate() {
        setInterval(() => {
          this.updateDateTime();
        }, 1000);
      },
      async fetchBranches() {
        try {
          const token = localStorage.getItem('authToken'); 
          const response = await fetch(`${this.$BASE_API_URL}/api/branches`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          });
  
          if (!response.ok) {
            throw new Error('Failed to fetch branches');
          }
  
          const data = await response.json();
          this.branches = data.data;
        } catch (error) {
          console.error('Error fetching branches:', error);
          this.$toast.error('Failed to load branch data');
        }
      },
      validateForm() {
        this.errors = {};
        let isValid = true;
        
        // Password validation
        // if (this.form.password.length < 8) {
        //   this.errors.password = ['Password must be at least 8 characters long'];
        //   isValid = false;
        // }
        
        return isValid;
      },
      async handleRegister() {
        // Clear previous errors
        this.errors = {};
        
        // Validate form
        if (!this.validateForm()) {
          return;
        }
        
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          if(this.form.branchId != localStorage.getItem('branchId')){
            const branchName = localStorage.getItem('branchName');
            this.$toast.error(`You can only add waiter to ${branchName}`);
            return;
          }
          const token = localStorage.getItem('authToken'); 
          const payload = {
            name: this.form.name,
            branchId: this.form.branchId,
            password: String(this.form.password),
            isSuspend: this.form.isSuspend,
          };
          
          const response = await fetch(`${BASE_API_URL}/api/waiters`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
          });
  
          const data = await response.json();
  
          if (response.ok) {
            this.$toast.success('Waiter created successfully!');
            this.$router.push('/waiters'); 
          } else {
            if (data.errors) {
              this.errors = data.errors;
              const firstError = Object.values(data.errors)[0][0];
              this.$toast.error(firstError);
            } else {
              this.$toast.error(data.message || 'Registration failed');
            }
          }
        } catch (error) {
          console.error('Error:', error);
          this.$toast.error('An error occurred. Please try again.');
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
      clearForm() {
        this.$router.go(-1);
        this.form = {
          name: '',
          branchId: '',
          isSuspend: false,
          password: ''
        };
        this.errors = {};
      },
    },
  };
  </script>
  
  <style scoped>
  .form-control {
    margin-bottom: 15px;
  }
  .form-check {
    margin-top: 10px;
  }
  .btn {
    padding: 8px 20px;
  }
  .text-danger {
    font-size: 0.875em;
  }
  </style>